//CRN_20250502 - Ideal for DevExtreme-Datagrid, useless for NgbModals
//CRN_20250502 - For NgbModals use PageCompMenuBootstrapComponent

import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ExceptionsService } from "../../services/utelize/general/exceptions-service";
import { MenuItem } from "primeng/api";
import { OverlayPanel } from "primeng/overlaypanel";

@Component({
  selector: 'app-page-comp-menu-primeng',
  templateUrl: './page-comp-menu-primeng.component.html',
  styleUrls: ['./page-comp-menu-primeng.component.scss']
})

export class PageCompMenuPrimeNgComponent implements OnInit {
  
  @Input() menuItems: MenuItem[] | undefined;
  
  @ViewChild('menuPanel') menuPanel!: OverlayPanel;

  constructor(
    private exceptionsService: ExceptionsService
  ) {
    
  }

  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
